
const Notfound = () => {
  return (
    <div>
      Notfound
    </div>
  )
}

export default Notfound
